import { render, staticRenderFns } from "./promotionData.vue?vue&type=template&id=4d9a431a&"
import script from "./promotionData.vue?vue&type=script&lang=js&"
export * from "./promotionData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d9a431a')) {
      api.createRecord('4d9a431a', component.options)
    } else {
      api.reload('4d9a431a', component.options)
    }
    module.hot.accept("./promotionData.vue?vue&type=template&id=4d9a431a&", function () {
      api.rerender('4d9a431a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/promotionData.vue"
export default component.exports